import { msg } from 'gt-react';
import { ArrowsLeftRightIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requirePermission,
} from '../../route';

const StagedInternalTransactionsPage = lazyRouteComponent(
  () => import('./StagedInternalTransactionsPage'),
  'StagedInternalTransactionsPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit/staged-internal',
  validateSearch: z.object({
    filters: z.record(z.string(), z.array(z.string())).optional(),
    transactionId: z.string().optional(),
    view: z.enum(['as400', 'v2']).optional(),
    page: z.number().int().min(1).optional(),
  }),
  staticData: {
    app: {
      nav: {
        label: msg('Staged Internal Transactions', {
          context: 'sidebar nav label, Ship and Debit section',
        }),
        icon: <ArrowsLeftRightIcon className="h-4 w-4" weight="fill" />,
        group: 'Ship and Debit',
        order: 16,
      },
      access: {
        modulesAnyOf: [ProductModule.SHIP_AND_DEBIT],
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.SDTransaction },
        ],
      },
    },
  },
  component: StagedInternalTransactionsPage,
  loader: () => ({
    crumb: msg('Staged Internal Transactions', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.SHIP_AND_DEBIT],
    });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.SDTransaction,
    });
  },
});
